module.exports = __webpack_public_path__ + "img/ikone-logo.0a056064.png";